import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getSiteConfig } from "../services/api";
import { LogoMark } from "./Logo";

// Matches TERMS_VERSION in backend/src/models/User.js. Change both when the terms or privacy policy change.
export const LEGAL_UPDATED = "October 22, 2026";
export const OPERATOR = "Ayush Srivastava";

export function LegalSection({ title, children }) {
  return (
    <section className="mb-4">
      <h2 className="h5 fw-semibold mb-2">{title}</h2>
      {children}
    </section>
  );
}

// A mailto link to CONTACT_EMAIL, or a plain fallback before it's set.
export function ContactLink() {
  const [email, setEmail] = useState("");
  useEffect(() => {
    getSiteConfig().then((c) => setEmail(c.contactEmail));
  }, []);
  return email ? <a href={`mailto:${email}`}>{email}</a> : "the email address on this site";
}

function LegalPage({ title, children }) {
  useEffect(() => {
    document.title = `${title} · Plateo`;
    return () => {
      document.title = "Plateo";
    };
  }, [title]);

  return (
    <div className="legal-page">
      <header className="legal-header">
        <Link to="/" className="brand">
          <LogoMark />
          <span className="brand-text">Plateo</span>
        </Link>
      </header>
      <article className="legal-body">
        <h1 className="h3 fw-bold mb-1">{title}</h1>
        <p className="text-muted small mb-4">Last updated {LEGAL_UPDATED}</p>
        {children}
      </article>
      <nav className="legal-footer">
        <Link to="/terms">Terms of service</Link>
        <Link to="/privacy">Privacy policy</Link>
        <Link to="/">Plateo</Link>
      </nav>
    </div>
  );
}

export default LegalPage;
